import { render, staticRenderFns } from "./IntegralChange.vue?vue&type=template&id=932d1330&scoped=true"
import script from "./IntegralChange.vue?vue&type=script&lang=js"
export * from "./IntegralChange.vue?vue&type=script&lang=js"
import style0 from "./IntegralChange.vue?vue&type=style&index=0&id=932d1330&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_8432db7643500554ffee61cb980ae8ea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "932d1330",
  null
  
)

export default component.exports